import Vue from 'vue'
import VueRouter from 'vue-router'
import { admin } from '@/router/routes/admin'
import { user } from '@/router/routes/user'
import { host } from '@/router/routes/host'
import { auth } from '@/router/routes/auth'
import { anonymous } from './routes/anonymous'

Vue.use(VueRouter)

/**
 auth
 - false = nesmi byt prihlasen
 - true = musi byt prihlasen
 - null/undefined = muze byt prihlasen
 */
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    ...admin,
    ...user,
    ...host,
    ...auth,
    ...anonymous
  ]
})

router.beforeEach((to, from, next) => {
  const currentUser = JSON.parse(localStorage.getItem('user'))
  if (to.meta.auth === false && currentUser) {
    return next({ name: 'homepage' })
  }
  if (to.meta.auth && !currentUser) {
    return next({ name: 'homepage' })
  }
  if (to.meta.roles && currentUser && !to.meta.roles.includes(currentUser.roleId)) {
    if (currentUser.roleId === 3) {
      return next('/host/dashboard')
    }
    if (currentUser.roleId === 4) {
      return next('/homepage')
    }
    if (currentUser.roleId === 1 || currentUser.roleId === 2) {
      return next('/admin/dashboard')
    }
  }
  return next()
})

export default router
